import * as React from "react";
import {
    CheckboxGroupInput,
    DeleteButton,
    Edit, ReferenceInput,
    required,
    SaveButton,
    SelectInput,
    SimpleForm,
    TextInput,
    Toolbar,
    SimpleShowLayout
} from 'react-admin';
import DeleteWithCustomConfirmButton from 'ra-delete-with-custom-confirm-button';
import Delete from '@material-ui/icons/Delete';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import checkPermission from "../../helpers/permission_handler";
import {USERTYPES} from "../../constants/userTypes";
import CustomAside from "../CustomAside/CustomAside";
import getUserTypes from "../../helpers/get_user_types";

const PageTitle = ({record}) => {
    return <span>User Types - Edit User Type {record ? `${record.name}` : ''}</span>;
};

const SectionTitle = ({label}) => {
    return (
        <Typography variant="h6" gutterBottom>
            {label}
        </Typography>
    );
};

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    name: {display: 'inline-block'},
    type: {display: 'inline-block', marginLeft: 32},
});

// Define your custom contents of confirm dialog
const DeleteConfirmContent = props => {
    return (
        <SimpleShowLayout {...props} />
    );
};

const CustomToolbar = ({permissions, ...props}) => (
    <Toolbar {...props} classes={useStyles()}>
        <SaveButton/>
        {permissions && checkPermission(permissions, {adminUserRole: ['delete']}) &&
        <DeleteWithCustomConfirmButton
            title={"Are you sure?"}
            content={DeleteConfirmContent}
            label='Delete'                  // label of delete button (default: 'Delete')
            confirmColor='warning'          // color of delete button ('warning' or 'primary', default: 'warning')
            ConfirmIcon={Delete}            // icon of delete button (default: 'Delete')
            cancel='Cancel'                 // label of cancel button (default: 'Cancel')
            CancelIcon={ErrorOutline}       // icon of cancel button (default: 'ErrorOutline')
            undoable={false}/>}
    </Toolbar>
);

export const RoleEdit = ({permissions, ...props}) => {
    const classes = useStyles(props);

    return (
        <Edit {...props} aside={<CustomAside {...props}/>} title={<PageTitle/>}>
            <SimpleForm
                toolbar={<CustomToolbar permissions={permissions}/>}
                variant="outlined"
                redirect={'/roles'}
            >
                <TextInput
                    source="name"
                    validate={[required()]}
                    formClassName={classes.name}
                />
                <ReferenceInput
                    source="type"
                    reference="types"
                    label="Type"
                    validate={[required()]}
                    formClassName={classes.inline}
                ><SelectInput optionText="name"/>
                </ReferenceInput>
                <SectionTitle label="User Permissions"/>
                <CheckboxGroupInput
                    source="permissions.outgoing"
                    label="Outgoing Referrals"
                    choices={[
                        {id: 'view', name: 'View'},
                        {id: 'create', name: 'Create'},
                        {id: 'edit', name: 'Edit'},
                        {id: 'delete', name: 'Delete'},
                    ]}
                />
                <CheckboxGroupInput
                    source="permissions.incoming"
                    label="Incoming Referrals"
                    choices={[
                        {id: 'view', name: 'View'},
                        {id: 'edit', name: 'Edit'},
                    ]}
                />
                <CheckboxGroupInput source="permissions.report" label="Reports" choices={[
                    {id: 'create', name: 'Create'},
                ]}/>
                <SectionTitle label="Admin Permissions"/>
                <CheckboxGroupInput
                    source="permissions.adminUser"
                    label="User Manager"
                    choices={[
                        {id: 'view', name: 'View'},
                        {id: 'create', name: 'Create'},
                        {id: 'edit', name: 'Edit'},
                        {id: 'delete', name: 'Delete'},
                    ]}
                />
                <CheckboxGroupInput source="permissions.adminUserRole" label="User Type" choices={[
                    {id: 'view', name: 'View'},
                    {id: 'create', name: 'Create'},
                    {id: 'edit', name: 'Edit'},
                    {id: 'delete', name: 'Delete'},
                ]}/>
                <CheckboxGroupInput source="permissions.adminFile" label="Files" choices={[
                    {id: 'view', name: 'View'},
                    {id: 'create', name: 'Create'},
                    {id: 'edit', name: 'Edit'},
                    {id: 'delete', name: 'Delete'},
                ]}/>
                <CheckboxGroupInput source="permissions.adminReport" label="Reports" choices={[
                    {id: 'create', name: 'Create'},
                ]}/>
            </SimpleForm>
        </Edit>
    );
};